import { Page } from "../../Container/page";
import { getTitles } from "../../helpers/titles";
import { parseFingerlingData } from "../../helpers/data-parses";

export const FingerlingsPage = () => {
    return (
        <Page
            titles={getTitles("fingerlings")}
            breadCrumb={
                <div className="flex text-gray-400">
                    <p>FISH MANAGEMENT / </p>&nbsp;
                    <a
                        href="/fish-management/fingerlings-restocking"
                        className="hover:text-purple-600"
                    >
                        {" "}
                        FINGERLING RESTOCKING
                    </a>
                </div>
            }
            header={"Fingerlings Restocking"}
            url={"fingerlings"}
            parseData={parseFingerlingData}
        />
    );
};
